






































import blockMixin from './../BlockMixin.vue'
import uploadMixin from './../UploadMixin.vue'

export default {
  name: 'teaser'

  mixins: [blockMixin, uploadMixin]

  data: -> {
    fields: {
      title: ''
      text: ''
      image: ''
      image_id: ''
      link: ''
    }
  }

  methods: {
    updateImage: (event) ->
      this.uploadImage(event)

    removeImage: ->
      this.block.fields.image = ''
      this.block.fields.image_id = ''
      # TODO: ugly
      this.$el.querySelector('.bb8-block-teaser-image-fileinput').value = ''

    removeBlock: (event, checkUrl = false) ->
      return if checkUrl && event.target.value.length >= 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/TeaserBlock.vue